<!--suppress JSUnfilteredForInLoop -->
<template>
  <footer id="contato" class="text-white section-shaped my-0 pb-0 footer bg-default">
    <div class="container">
      <hr class="my-3">
      <div class="text-center py-4">
        <div class="copyright">
          &copy; {{ year }}
          <a class="text-muted text-center" href="#" target="_self" rel="noopener">Portal Janela Única</a>.
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  import Spinner from '../components/Spinner'
  import { formMixin } from '../mixins/formMixin'

  export default {
    name: 'app-footer',
    components: { Spinner },
    mixins: [ formMixin ],
    data() {
      return {
        year: new Date().getFullYear(),
        isLoading: false,
        form : {
          model: {
            nome: '',
            email: '',
            assunto:'',
            mensagem: ''
          },
          config: {
            apiUri: 'api/contato',
            httpMethod: 'post'
          },
          inputs: {
            nome: {
              type: 'text',
              state: null,
              invalidFeedback:''
            },
            email: {
              type: 'text',
              state: null,
              invalidFeedback:''
            },
            assunto: {
              type: 'password',
              state: null,
              invalidFeedback:''
            },
            mensagem: {
              type: 'password',
              state: null,
              invalidFeedback:''
            }
          }
        }
      }
    },
  }
</script>

<style>

  .loading {
    position: absolute;
    z-index: 5;
    top: 35%;
    right: 47%;
  }

  @media only screen and (max-width: 500px) {
    .loading {
      right: 45% !important;
    }
  }

</style>
